import { render, staticRenderFns } from "./portDetail.vue?vue&type=template&id=81a1de94"
import script from "./portDetail.vue?vue&type=script&lang=js"
export * from "./portDetail.vue?vue&type=script&lang=js"
import style0 from "./portDetail.vue?vue&type=style&index=0&id=81a1de94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports